module.exports = __webpack_public_path__ + "static/media/husky-3380548_640-min.ad25ab41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/husky-3380548_640-min.jpg
// module id = 133
// module chunks = 0